import React from "react";
import { Notification } from "react-admin";

const uNotification = (props) => {
  return (
    <Notification
      {...props}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    />
  );
};

export default uNotification;
